module.exports = "/_next/static/images/game-2-intro-tutorial-media-uv-46edfa74c86560fbb73c206671c61969.png";